import React, { Component } from 'react'
import { Label, Paragraph } from 'atoms/Texts'
import { LabelWithStatus } from 'molecules/LabelEnhanced'
import { ButtonReg } from 'atoms/Buttons'
import MapView from 'atoms/MapView'
import GridPhotos from 'molecules/GridPhotos'
import CoordinateField from 'molecules/CoordinateField'
import {
  MainWrapper,
  ModalHead,
  ModalFooter,
  LevelRowContainer,
  ViewPositionRow
} from '../styles'
import { withTheme } from 'styled-components'
import moment from 'moment'

export class SupportRequestView extends Component {
  state = {
    showPreview: false,
  }

  renderTitle(title, mb = '0px') {
    const { theme } = this.props
    return (
      <Label lineheight={'14px'} size={'12px'} color={theme.mocaGrey} mb={mb}>
        {title}
      </Label>
    )
  }

  renderBody(body) {
    return (
      <Paragraph size={'14px'}>
        {body}
      </Paragraph>
    )
  }

  render() {
    const { theme, taskData, fnSwitch } = this.props
    return (
      <MainWrapper>
        <ModalHead>
          <Label lineheight={'29px'} size={'24px'} mb={'0px'}>
            View Support Request
          </Label>
        </ModalHead>
        {taskData ?
          <LevelRowContainer>

            <div className={'row col-12 mx-0 px-0'}>
              <div className={'col-12 px-0'}>
                {this.renderTitle('Pit')}
                {this.renderBody(taskData.pit.name)}
              </div>
              <div className={'col-12 px-0'}>
                {this.renderTitle('Title')}
                {this.renderBody(taskData.title)}
              </div>
              <div className={'col-12 px-0'}>
                {this.renderTitle('Description')}
                {this.renderBody(taskData.description)}
              </div>
            </div>

            <div className={'row col-12 mx-0 px-0 mb-3'}>
              <div className={'col-4 px-0 pr-2'}>
                <LabelWithStatus
                  text={'Severity'}
                  value={taskData.severity}
                  transparent={true}
                  lineheight={'14px'}
                  size={'12px'}
                  weight={'bold'}
                  color={theme.mocaGrey}
                />
              </div>
              <ViewPositionRow>
                {this.renderTitle('Position')}
                <CoordinateField
                  pos={taskData.position}
                  disabled={true}
                  ml={'10px'}
                />
              </ViewPositionRow>
              <div className='col-1 px-0 pr-2 align-self-center'>
                <ButtonReg 
                  onClick={() => this.setState(prev => ({ showPreview: !prev.showPreview }))} 
                  btnIcon={'map'} 
                  bg="#463291" 
                  width="100%"
                  height="2.1rem"
                />
              </div>
            </div>

            {this.state.showPreview && <div className={'row col-12 mx-0 px-0 mb-3'}>
              <MapView pos={taskData.position} />
            </div>}

            <div className={'row col-12 mx-0 px-0'}>
              <div className={'col-6 px-0 pr-2'}>
                {this.renderTitle('Seam')}
                {this.renderBody(taskData.seam)}
              </div>
              <div className={'col-6 px-0 pr-2'}>
                {this.renderTitle('Section')}
                {this.renderBody(`${taskData.sectionPrefix} ${taskData.sectionFrom} - ${taskData.sectionTo}`)}
              </div>
            </div>

            <div className={'row col-12 mx-0 px-0'}>
              <div className={'col-6 px-0 pr-2'}>
                {this.renderTitle('Concerned Department')}
                {this.renderBody(taskData.concernedDepartment)}
              </div>
              <div className={'col-6 px-0 pr-2'}>
                {this.renderTitle('Deadline')}
                {this.renderBody(moment(taskData.dateDeadline).calendar())}
              </div>
            </div>

            <div className={'row col-12 mx-0 px-0 mb-3'}>
              <div className={'col-12 px-0'}>
                {this.renderTitle('Photos', '15px')}
                  <GridPhotos photos={taskData.photos} previewOnClick largeMode />
              </div>
            </div>

            <ModalFooter pos='c'>
              <ButtonReg onClick={fnSwitch} btnTxt={'Close'} />
            </ModalFooter>

          </LevelRowContainer> :
          <div>No data loaded.</div>
        }
      </MainWrapper>
    )
  }
}

export default withTheme(SupportRequestView)
